import PageMargin from "./PageMargin";

export default function Shimmer() {
  return (
    <div>
      <div className="overflow-hidden rounded-[48px] mx-2 md:mx-4 bg-gray-200 animate-pulse">
        <div className="min-h-[600px] max-h-[600px] object-cover hidden md:block">
          <div className="min-h-[500px] max-h-[600px] object-cover md:block" />
        </div>
        <div className="min-h-[500px] max-h-[600px] object-contain bg-grey md:hidden" />
      </div>
      <PageMargin noBottomMargin>
        <div className="absolute bottom-10 ml-4 md:ml-6 left-8 md:left-12 lg:left-auto">
          <div className="uppercase text-white text-base md:text-2xl bg-gray-200 animate-pulse h-6 w-40 md:w-64 mb-2 md:mb-3" />
          <div className="uppercase font-title text-[#FEFE05] bg-gray-200 animate-pulse h-12 md:h-20 w-[16rem] md:w-[24rem] mb-2 md:mb-3" />
          <div className="text-white flex items-center text-sm mb-4 bg-gray-200 animate-pulse h-4 w-20 md:w-32" />
          <div className="pill-btn bg-gray-200 animate-pulse h-8 w-20 md:w-32" />
        </div>
      </PageMargin>
    </div>
  );
}
